import { Divider as Divider_ } from "@chakra-ui/react"
import { forwardRef } from "react"
export const Divider = forwardRef(({ ...props }, ref) => {
    return <Divider_ ref={ref} borderColor="blackAlpha.300" {...props}>{props?.children}</Divider_>
});